<mat-spinner diameter="80" color="accent"></mat-spinner>

